import type { ReactNode } from 'react';
import { X } from 'lucide-react';

export type BulkActionBarProps = {
  selectedCount: number;
  totalMatching: number;
  isAllOnPageSelected: boolean;
  filterMode: boolean;
  onEscalateToFilter: () => void;
  onClear: () => void;
  children: ReactNode;
};

export function BulkActionBar({
  selectedCount,
  totalMatching,
  isAllOnPageSelected,
  filterMode,
  onEscalateToFilter,
  onClear,
  children,
}: BulkActionBarProps) {
  if (selectedCount === 0 && !filterMode) return null;
  return (
    <div className="pointer-events-none fixed bottom-4 left-1/2 z-40 -translate-x-1/2 px-4">
      <div className="pointer-events-auto flex max-w-[calc(100vw-2rem)] flex-wrap items-center gap-3 rounded-lg border border-border bg-card px-4 py-2 shadow-lg">
        <span className="text-sm font-medium text-foreground">
          {filterMode ? `Tất cả ${totalMatching} matching` : `${selectedCount} đã chọn`}
        </span>
        {!filterMode && isAllOnPageSelected && totalMatching > selectedCount && (
          <button
            type="button"
            onClick={onEscalateToFilter}
            className="text-sm text-primary hover:underline"
          >
            Chọn tất cả {totalMatching} matching filter
          </button>
        )}
        <div className="hidden h-5 w-px bg-border sm:block" />
        <div className="flex items-center gap-2">{children}</div>
        <div className="hidden h-5 w-px bg-border sm:block" />
        <button
          type="button"
          onClick={onClear}
          className="inline-flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground"
        >
          <X size={14} strokeWidth={1.5} />
          Xóa lựa chọn
        </button>
      </div>
    </div>
  );
}
